import { createSlice } from "@reduxjs/toolkit";
import { LocalStoragePersistanceService } from "persist/LocalStorage";
import { FolderState } from "state/types";
import { Folder, File } from "views/DataRoom/types";

const initialState: FolderState = {
  recentFolder: {
    id: "recentFolder",
    name: "Recents",
    folders: [],
    files: [],
    date: new Date().toISOString(),
    comments: [],
  },
  bookmarkFolder: {
    id: "bookmarkFolder",
    name: "Bookmark",
    folders: [],
    files: [],
    date: new Date().toISOString(),
    comments: [],
  },
};
const localStore = new LocalStoragePersistanceService();
export const usersSlice = createSlice({
  name: "folderState",
  initialState,
  reducers: {
    setRecentFolder : (state, action) => {
      state.recentFolder = action.payload
    },
    addRecentFolder: (state, action) => {
      const folder: Folder = action.payload;
      const indexForFolder = state.recentFolder.folders.findIndex(
        (folderObj) => folderObj.id === folder.id
      );
      if (indexForFolder >= 0) {
        delete state.recentFolder.folders[indexForFolder];
      }

      state.recentFolder.folders.unshift(folder);
      localStore.setItem("recent", state.recentFolder);
    },
    addRecentFile: (state, action) => {
      const file: File = action.payload;

      const index = state.recentFolder.files.findIndex(
        (fileObj) => fileObj.id === file.id
      );
      if (index >= 0) {
        delete state.recentFolder.files[index];
      }

      state.recentFolder.files.unshift(file);
      localStore.setItem("recent", state.recentFolder);
    },

    setBookmarkFolder : (state, action) => {
      state.bookmarkFolder = action.payload
    },
    addBookmarkFolder: (state, action) => {
      const { folder, status } = action.payload;
      const indexForFolder = state.bookmarkFolder.folders.findIndex(
        (folderObj) => folderObj.id === folder.id
      );
      if (indexForFolder >= 0 && !status) {
        delete state.bookmarkFolder.folders[indexForFolder];

        state.bookmarkFolder.folders = state.bookmarkFolder.folders.filter(n => n)
      } else if (indexForFolder === -1 && status) {
        state.bookmarkFolder.folders.push(folder);
      }
      localStore.setItem("bookmark", state.bookmarkFolder);
    },
    addBookmarkFile: (state, action) => {
      const { file, status } = action.payload;
      const indexForFile = state.bookmarkFolder.files.findIndex(
        (fileObj) => fileObj.id === file.id
      );
      if (indexForFile >= 0 && !status) {
        delete state.bookmarkFolder.files[indexForFile];
        state.bookmarkFolder.files = state.bookmarkFolder.files.filter(n => n)

      } else if (indexForFile === -1 && status) {
        state.bookmarkFolder.files.push(file);
      }
      localStore.setItem("bookmark", state.bookmarkFolder);
    },
  },
});

// Actions
export const {
  addRecentFolder,
  addRecentFile,
  addBookmarkFolder,
  addBookmarkFile,
  setBookmarkFolder,
  setRecentFolder
} = usersSlice.actions;

export default usersSlice.reducer;
